import React from 'react'

type CustomIframeProps = {
  src: string;
  title?: string;
  allow?: string;
  allowFullScreen?: boolean;
} & React.HTMLAttributes<HTMLIFrameElement>

const CustomIframe: React.FC<CustomIframeProps> = ({ src, ...restProps }) => {
  return (
    <iframe
      src={src}
      style={{ width: '100%', height: '100vh' }}
      {...restProps}
    />
  )
}

export default CustomIframe
